export class ErrorInfo {
    constructor({ error, scope, context, type, message }) {
        this.error = error;
        this.scope = scope;
        this.context = context;
        this.type = type;
        this.message = message;
    }

    /**
     * @type {Error}
     */
    error;

    /**
     * Scope (function, method, module, class or global) name
     * @type {string}
     */
    scope = '';

    /**
     * Object (vue component, class instance) context reference
     * @type {*|null}
     */
    context = null;

    /**
     *
     * @type {string}
     */
    type;

    /**
     * Human-readable message
     * @type {string}
     */
    message;
}
